import { Box, Typography } from '@branch-messenger/willow-ui'
import styled from 'styled-components'

export const SidebarDetailHeader = styled(Typography).attrs({
  $size: 'xl',
  $bold: true,
})``

export const SidebarDetailSection = styled(Box).attrs({
  $display: 'flex',
  $fullWidth: true,
  $direction: 'column',
  $align: 'start',
  $gap: 6,
})`
  border-top: 1px solid ${({ theme }) => theme.colors.gray};
  padding-top: ${({ theme }) => theme.space[6]};

  &:first-child {
    border-top: none;
    padding-top: 0;
  }
`
